import React, {useState, useEffect, useMemo} from 'react';

const getImageSrc = (uuid, scaleVersion, rotation, effect) => {
    let type = 0;
    switch (effect) {
        case "original":
            type = 0;
            break;
        case "bw":
            type = 1;
            break;
        case "sepia":
            type = 2;
            break;
    }
    return `/system/XPhoto.php?uuid=${uuid}&scaleversion=${scaleVersion}&rotation=${rotation}&type=${type}`;
}

// Our hook
export default function useEpmsImage(uuid, options) {
    // State and setters for debounced value
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const url = useMemo ( () => {
        return getImageSrc(uuid, options.size || 320, options.rotation || 0, options.effect || 'original');
    }, [uuid, options])

    useEffect(() => {
        let active = true;

        setLoading(true);

        const loadImage = () => {
            const img = new Image();
            img.onload = onImageLoad;
            img.onerror = onImageError;
            img.src = url;
        }

        const onImageLoad = () => {
            if (active) {
                setLoading(false)
            }
        }

        const onImageError = () => {
               setTimeout(() => {
                   if (active) {
                       loadImage();
                   }
               }, 3000)
        }

        loadImage();

        return () => {
            active = false;
        }
    }, [url]);

    return { url, loading, error};
}